/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Espacio para la amistad",
      "Encontrá nuevas amistades en Bumble For Friends | Bumble",
      "Descargar en App Store",
      "Descargar en Google Play",
      "Un espacio exclusivo para hacer nuevas amistades",
      "Descubrí gente por la zona para armar lazos genuinos.",
      "Encontrá amistades para cada momento de tu vida",
      "¿Recién llegás a la ciudad? ¿Con ganas de cambios? Te esperan nuevas amistades.",
      "Un espacio seguro para todo el mundo",
      "Te invitamos a disfrutar el lado bueno de las redes, donde podés mostrarte como realmente sos.",
      "Descarga la aplicación",
      "¡Juntate con personas que les guste lo mismo que a vos!",
      "Armá nuevos grupos con Plans en Bumble For Friends",
      "Te invitaron a unirte a Plans",
      "Plans es una nueva función de Bumble For Friends para unirse a grupos o armarlos, y reunirte con nuevas amistades por tu zona.",
      "Gestionar cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
